import { Component } from "@angular/core";
import {Platform} from "@ionic/angular";
import { Logger, LoggingService } from "ionic-logging-service";
import {interval} from "rxjs";
// eslint-disable-next-line @typescript-eslint/naming-convention

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"]
})
export class AppComponent {

  private logger: Logger;

  constructor( private platform: Platform, private loggingService: LoggingService) {
    this.initializeApp();
  }

  async initializeApp() {
    this.platform.ready().then(async () => {
      this.logger = this.loggingService.getLogger("BestoGo.App");
      // await SplashScreen.hide();
      // console.log("Hiding status bar", StatusBar);
      // await StatusBar.hide();
      /*
      const subscription = interval(1000).subscribe(async () => {
        const info = await StatusBar.getInfo();
        if (info.visible) { await StatusBar.hide(); }
      }); */
      if (this.platform.is("ios")) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const win: any = <any> window;
        /* this.logger.info("initializeApp", "Printers: ", win.starprnt); */
        /* win.starprnt.portDiscovery("All", (success) => {
          this.logger.info("initializeApp", "Success:", success);
          }, (error) => {
            this.logger.error("initializeApp", "Error: ", error);
          }
        ); */
        this.logger.info("initializeApp", "Starting to synch cookies2", win.wkWebView);
        win.wkWebView.injectCookie("https://restolution.fi/");
        win.wkWebView.injectCookie("https://web.restolution.fi/");
        win.wkWebView.injectCookie("https://web.restolution.fi/api/", () => {
          this.logger.info("initializeApp", "Success injectCookie");
        });
      }
    });
  }
}
